import React from 'react'
import Media from 'sb-media'
import { FormattedMessage, FormattedHTMLMessage } from 'sb-react-intl'

import Logo from 'components/_new/ui/Logo/Logo'
import Center from 'components/_new/layout/Center/Center'

import messages from './messages'
import s from './500.scss'

import mobileImage from '!!src-loader!./images/mobile-500.jpg'
import desktopImage from '!!src-loader!./images/desktop-500.jpg'


const Page500 = ({ err }) => {
  console.error(err)

  let message

  if (typeof err === 'string') {
    message = err
  }
  else {
    try {
      message = `${err.message}<br>${err.stack}`
    }
    catch (error) {
      message = error
    }
  }

  const content = (
    <div className={s.content}>
      <Logo className={s.logo} dark />
      <FormattedHTMLMessage className={s.title} tag="div" {...messages.title} />
      <FormattedMessage className={s.subTitle} tag="div" {...messages.subTitle} />
      <Media mobile>
        {
          (isMobile) => (
            <img
              className={s.image}
              {...(isMobile ? mobileImage : desktopImage)}
              alt=""
            />
          )
        }
      </Media>
      <div
        style={{ display: 'none' }}
        id="500-errorText"
        dangerouslySetInnerHTML={{ __html: message || 'Error: unknown' }}
      />
    </div>
  )

  return (
    <Media mobile>
      {
        (isMobile) => isMobile ? (
          content
        ) : (
          <Center>
            {content}
          </Center>
        )
      }
    </Media>
  )
}


export default Page500
